import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="custom-field-form"
export default class extends Controller {
  static targets = ["optionsField"];

  connect() {
    this.boundToggleOptionsField = this.#toggleOptionsField.bind(this);
    this.#kindRadioButtons().forEach((kindRadioButton) => {
      kindRadioButton.addEventListener("change", this.boundToggleOptionsField);
    });
  }

  disconnect() {
    this.#kindRadioButtons().forEach((kindRadioButton) => {
      kindRadioButton.removeEventListener(
        "change",
        this.boundToggleOptionsField,
      );
    });
  }

  #canSetOptions(kind) {
    return ["checkboxes", "radio_buttons", "select_box"].includes(kind);
  }

  #kindRadioButtons() {
    return document.querySelectorAll('input[name="custom_field[kind]"]');
  }

  #toggleOptionsField(e) {
    const kindRadioButton = e.target;
    if (this.#canSetOptions(kindRadioButton.value)) {
      this.optionsFieldTarget.classList.remove("hidden");
      kindRadioButton
        .closest("div.radio-button")
        .after(this.optionsFieldTarget);
    } else {
      this.optionsFieldTarget.classList.add("hidden");
    }
  }
}
